module.exports = __webpack_public_path__ + "img/step-anchor-without-anchor.9caf4428.png";